import { downgradeComponent, downgradeInjectable } from "@angular/upgrade/static";
import { AccountFeatures } from "@app/enum/account/AccountFeature";
import { DeviceProfileService } from "@app/services/device-profile.service";
import { UserRole } from "@services/accountFeature.service";
import { AuthorizationService } from "@services/authorization.service";
import { ZoneService } from "@temperature/_services/zone.service";
import { StateProvider } from "@uirouter/angularjs";
import * as angular from "angular";
import { PageStateNames } from "../../../class/PageStateNames";
import { AccountSettingsManagerComponent } from "./account-settings/account-settings-manager.component";
import { AccountSettingsSaveWarningComponent } from "./account-settings/account-settings-save-warning/account-settings-save-warning.component";
import { ChannelThumbnailComponent } from "./cameras/camera-channels-editor/channel-thumbnail/channel-thumbnail.component";
import { CameraVehiclesManagerComponent } from "./cameras/camera-vehicles-manager/camera-vehicles-manager.component";
import { ContextualSpeedingByRoadComponent } from "./contextual-speeding-settings-manager/contextual-speeding-by-road/contextual-speeding-by-road.component";
import { ContextualSpeedingByVehicleComponent } from "./contextual-speeding-settings-manager/contextual-speeding-by-vehicle/contextual-speeding-by-vehicle.component";
import { ContextualSpeedingRoadEditorComponent } from "./contextual-speeding-settings-manager/contextual-speeding-road-editor/contextual-speeding-road-editor.component";
import { ContextualSpeedingSettingsManagerComponent } from "./contextual-speeding-settings-manager/contextual-speeding-settings-manager.component";
import { ContextualSpeedingVehicleEditorComponent } from "./contextual-speeding-settings-manager/contextual-speeding-vehicle-editor/contextual-speeding-vehicle-editor.component";
import { DeviceProfileComparisonStatusLabelComponent } from "./device-profiles-manager/device-profile-comparison-status-label/device-profile-comparison-status-label.component";
import { DeviceProfileEditorComponent } from "./device-profiles-manager/device-profile-editor/device-profile-editor.component";
import { DeviceProfileVehiclePreviewComponent } from "./device-profiles-manager/device-profile-vehicle-preview/device-profile-vehicle-preview.component";
import { DeviceProfileVehicleViewComponent } from "./device-profiles-manager/device-profile-vehicle-view/device-profile-vehicle-view.component";
import { DeviceProfilesManagerComponent } from "./device-profiles-manager/device-profiles-manager.component";
import { DriversComponent } from "./driverassignment/driverassignment.component";
import { DrivingStyleAssociationsManagerComponent } from "./driving-styles-manager/driving-style-associations-manager/driving-style-associations-manager.component";
import { DrivingStyleEditorComponent } from "./driving-styles-manager/driving-style-editor/driving-style-editor.component";
import { DrivingStyleMetricEditorComponent } from "./driving-styles-manager/driving-style-metric-editor/driving-style-metric-editor.component";
import { DrivingStyleMetricSelectorComponent } from "./driving-styles-manager/driving-style-metric-selector/driving-style-metric-selector.component";
import { DrivingStyleMetricWeightingLabelComponent } from "./driving-styles-manager/driving-style-metric-weighting-label/driving-style-metric-weighting-label.component";
import { DrivingStyleVehiclePreviewComponent } from "./driving-styles-manager/driving-style-vehicle-preview/driving-style-vehicle-preview.component";
import { DrivingStylesManagerComponent } from "./driving-styles-manager/driving-styles-manager.component";
import { DrivingStylesService } from "./driving-styles-manager/driving-styles.service";
import { GeofenceDetailsInfoComponent } from "./geofences/geofenceDetailsInfo/geofenceDetailsInfo.component";
import { DeliveryProfileEditComponent } from "./geofences/geofenceEditor/delivery-profile/delivery-profile-edit.component";
import { DeliveryProfileViewComponent } from "./geofences/geofenceEditor/delivery-profile/delivery-profile-view.component";
import { GeofenceEditorComponent } from "./geofences/geofenceEditor/geofenceEditor.component";
import { GeofenceListComponent } from "./geofences/geofenceList/geofenceList.component";
import "./geofences/geofences.module";
import { GeofenceTagsComponent } from "./geofences/geofenceTags/geofenceTags.component";
import { GeofenceTagsEditComponent } from "./geofences/geofenceTagsEdit/geofenceTagsEdit.component";
import { GeofenceVisitsComponent } from "./geofences/geofenceVisits/geofenceVisits.component";
import { ResourceGeofencesComponent } from "./geofences/resourceGeofences.component";
import { GroupsListComponent } from "./groups/groups-list/groups-list.component";
import { ResourceManagementController } from "./resourceManagement.controller";
import { ResourceManagementNavigationModule } from "./resourceManagement.navigation";
import { SamlConfigurationComponent } from "./users/saml-configuration/saml-configuration.component";
import { UserActivityChartComponent } from "./users/userActivityChart/userActivityChart.component";
import { UserEditorComponent } from "./users/userEditor/user-editor.component";
import { UserEditorComponentOld } from "./users/userEditor/userEditor.component";
import { UserPermissionsComponent } from "./users/userPermissions/userPermissions.component";
import { UsersComponent } from "./users/users.component";
import { TemperatureZonesComponent } from './vehicles/temperatureProbes/temperature-zones-edit/temperature-zones-edit.component';
import { TemperatureProbesComponent } from "./vehicles/temperatureProbes/temperatureProbes.component";
import { TemperatureProfilesEditComponent } from "./vehicles/temperatureProbes/temperatureProfilesEdit/temperatureProfilesEdit.component";
import { InputStateDescriptionComponent } from "./vehicles/vehicleInputEditor/inputStateDescription/inputStateDescription";
import { VehicleInputEditorComponent } from "./vehicles/vehicleInputEditor/vehicleInputEditor.component";
import { VehicleInputTypeManagerComponent } from "./vehicles/vehicleInputEditor/vehicleInputTypeManager/vehicleInputTypeManager.component";
import { VehiclesComponent } from "./vehicles/vehicles.component";
import { VorMaintenanceComponent } from "./vor/vor.maintenance.component";
import { VorRecordEntryComponent } from "./vor/vorRecordEntryDialog/vorRecordEntry.component";
import { AutoDownloadConfigurationComponent } from "./cameras/camera-channels-editor/auto-download-configuration/auto-download-configuration.component";
import { AutoDownloadConfigurationEditorComponent } from "./cameras/camera-channels-editor/auto-download-configuration/editor/auto-download-configuration-editor.component";
import { GroupListComponent } from "./users/resourceGroupList/resourceGroupList.component";

export class Config {

    static PageStateName = PageStateNames.COMPONENTS_RESOURCEMANAGEMENT;

    constructor($stateProvider: StateProvider) {

        $stateProvider.state(ResourceManagementNavigationModule.DeviceProfilesManagement, {
            url: "/device-profiles",
            views: { "content@app": { component: "deviceProfilesManager" } },
            data: { translation: "Common.DeviceProfiles", subtitleTranslationKey: "DeviceProfilesManager.PageDescription" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([UserRole.Administrator])]
            }
        });

        $stateProvider.state(ResourceManagementNavigationModule.DrivingStylesManagement, {
            url: "/driving-styles",
            views: { "content@app": { component: "drivingStylesManager" } },
            data: { translation: "Common.DrivingStyles", subtitleTranslationKey: "DrivingStylesManager.PageDescription" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([UserRole.Administrator])]
            }
        });

        $stateProvider.state(ResourceManagementNavigationModule.EditDrivingStyle, {
            url: "/:drivingStyleId/edit",
            views: { "content-detail@app": { component: "drivingStyleEditor", bindings: { drivingStyleId: "drivingStyleId" } } },
            data: { translation: "DrivingStyleEditor.EditDrivingStyleTitle" },
            params: {
                drivingStyleId: {
                    squash: true,
                    value: null
                }
            },
            resolve: {
                drivingStyleId: ["$stateParams", ($stateParams) => { return $stateParams["drivingStyleId"]; }],
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([UserRole.Administrator])]
            }
        });

        $stateProvider.state(ResourceManagementNavigationModule.NewDrivingStyle, {
            url: "/driving-styles/new",
            views: { "content-detail@app": { component: "drivingStyleEditor" } },
            data: { translation: "DrivingStyleEditor.CreateNewDrivingStyleTitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([UserRole.Administrator])]
            }
        });

        $stateProvider.state(ResourceManagementNavigationModule.GroupsManagement, {
            url: "/groups",
            views: { "content@app": { component: "groupsList" } },
            data: { translation: 'Common.Groups' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageGroups,
                    UserRole.Administrator
                ])]
            }
        });
        $stateProvider.state(ResourceManagementNavigationModule.VehiclesManagement, {
            url: "/vehicles",
            views: { "content@app": { component: "resourceVehicles" } },
            data: { translation: 'Common.Vehicles' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageVehicles,
                    UserRole.Administrator
                ])]
            }
        });
        $stateProvider.state(ResourceManagementNavigationModule.DriversManagement, {
            url: "/drivers",
            views: { "content@app": { component: "driverAssignment" } },
            data: { translation: 'Common.Drivers' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageDrivers,
                    UserRole.Administrator
                ])]
            }
        });
        $stateProvider.state(ResourceManagementNavigationModule.UsersManagement, {
            url: "/users",
            views: { "content@app": { component: "resourceUsers" } },
            data: { translation: 'Common.Users' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.Administrator
                ])]
            }
        });
        $stateProvider.state(ResourceManagementNavigationModule.CameraManagement, {
            url: "/cameras",
            views: { "content@app": { component: "cameraVehiclesManager" } },
            data: { translation: 'Videos.Cameras', subtitleTranslationKey: "Videos.CameraAdminSubtitle" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.Administrator,
                    UserRole.ManageVehicles
                ], [AccountFeatures.Camera])]
            }
        });
        $stateProvider.state(ResourceManagementNavigationModule.ParentRoot, {
            abstract: true,
            url: "/admin",
            redirectTo: ResourceManagementNavigationModule.Default,
            views: { "module-navigation": {} },
            data: { translation: 'Common.Admin' },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([
                    UserRole.ManageDrivers,
                    UserRole.ManageGroups,
                    UserRole.ManageVehicles,
                    UserRole.Administrator
                ])]
            }
        });

        $stateProvider.state(ResourceManagementNavigationModule.Settings, {
            url: "/settings",
            views: { "content@app": { component: "accountSettingsManager" } },
            data: { translation: "AccountSettingsManager.PageTitle", subtitleTranslationKey: "AccountSettingsManager.PageDescription" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([UserRole.Administrator])],
                authorizeFoundationOrInternal: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeFoundationOrInternal()]
            }
        });

        $stateProvider.state(ResourceManagementNavigationModule.ContextualSpeedingSettings, {
            url: "/contextual-speeding-settings",
            views: { "content@app": { component: "contextualSpeedingSettingsManager" } },
            data: { translation: "ContextualSpeedingSettingsManager.PageTitle", subtitleTranslationKey: "ContextualSpeedingSettingsManager.PageDescription" },
            resolve: {
                authorize: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeForUser([UserRole.Administrator])],
                authorizeFoundationOrInternal: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeFoundationOrInternal()],
                authorizeDevOnly: ["authorizationService", (authorization: AuthorizationService) => authorization.authorizeDevOnly()]
            }
        });

    }
}

angular
    .module("app.resourceManagement", [
        "ui.router",
        "ngMaterial",
        "app.components.geofences"
    ])
    .config(["$stateProvider", Config])


    .service("zoneService", downgradeInjectable(ZoneService))
    .controller("resourceManagementController", ResourceManagementController)
    .component("resourceGroupList", new GroupListComponent)

    .component("driverAssignment", new DriversComponent())
    .directive("groupsList", downgradeComponent({ component: GroupsListComponent }))
    .component("geofenceDetailsInfo", new GeofenceDetailsInfoComponent())
    .component("resourceGeofences", new ResourceGeofencesComponent())
    .component("geofenceList", new GeofenceListComponent())
    .component("geofenceEditor", new GeofenceEditorComponent())
    .component("geofenceTags", new GeofenceTagsComponent())
    .component("geofenceVisits", new GeofenceVisitsComponent())
    .component("geofenceTagsEdit", new GeofenceTagsEditComponent())
    .component("resourceVehicles", new VehiclesComponent())
    .component("vehicleInputEditor", new VehicleInputEditorComponent())


    .component("temperatureProbes", new TemperatureProbesComponent())
    .component("temperatureProfilesEdit", new TemperatureProfilesEditComponent())

    .directive("temperatureZonesEdit", downgradeComponent({ component: TemperatureZonesComponent }))

    .component("resourceUsers", new UsersComponent())
    .component("userEditorOld", new UserEditorComponentOld())
    .directive("userEditor", downgradeComponent({ component: UserEditorComponent }))
    .component("userPermissions", new UserPermissionsComponent())
    .directive("samlConfiguration", downgradeComponent({ component: SamlConfigurationComponent }))

    .component("userActivityChart", new UserActivityChartComponent())

    .component("vehicleInputManager", new VehicleInputTypeManagerComponent())
    .component("inputStateDescription", new InputStateDescriptionComponent())

    .directive("drivingStylesManager", downgradeComponent({ component: DrivingStylesManagerComponent }))
    .directive("drivingStyleEditor", downgradeComponent({ component: DrivingStyleEditorComponent }))
    .directive("drivingStyleAssociationsManager", downgradeComponent({ component: DrivingStyleAssociationsManagerComponent }))
    .directive("drivingStyleMetricEditor", downgradeComponent({ component: DrivingStyleMetricEditorComponent }))
    .directive("drivingStyleMetricSelector", downgradeComponent({ component: DrivingStyleMetricSelectorComponent }))
    .directive("drivingStyleMetricWeightingLabel", downgradeComponent({ component: DrivingStyleMetricWeightingLabelComponent }))
    .directive("drivingStyleVehiclePreview", downgradeComponent({ component: DrivingStyleVehiclePreviewComponent }))
    .service("drivingStylesService", downgradeInjectable(DrivingStylesService))

    .directive("deviceProfilesManager", downgradeComponent({ component: DeviceProfilesManagerComponent }))
    .directive("deviceProfileEditor", downgradeComponent({ component: DeviceProfileEditorComponent }))
    .directive("deviceProfileVehicleView", downgradeComponent({ component: DeviceProfileVehicleViewComponent }))
    .directive("deviceProfileVehiclePreview", downgradeComponent({ component: DeviceProfileVehiclePreviewComponent }))
    .directive("deviceProfileComparisonStatusLabel", downgradeComponent({ component: DeviceProfileComparisonStatusLabelComponent }))
    .directive("deliveryProfileEdit", downgradeComponent({ component: DeliveryProfileEditComponent }))
    .directive("deliveryProfileView", downgradeComponent({ component: DeliveryProfileViewComponent }))

    .directive("accountSettingsManager", downgradeComponent({ component: AccountSettingsManagerComponent }))
    .directive("accountSettingsSaveWarning", downgradeComponent({ component: AccountSettingsSaveWarningComponent }))
    .directive("contextualSpeedingSettingsManager", downgradeComponent({ component: ContextualSpeedingSettingsManagerComponent }))
    .directive("contextualSpeedingByVehicle", downgradeComponent({ component: ContextualSpeedingByVehicleComponent }))
    .directive("contextualSpeedingByRoad", downgradeComponent({ component: ContextualSpeedingByRoadComponent }))
    .directive("contextualSpeedingRoadEditor", downgradeComponent({ component: ContextualSpeedingRoadEditorComponent }))
    .directive("contextualSpeedingVehicleEditor", downgradeComponent({component: ContextualSpeedingVehicleEditorComponent }))

    .directive("cameraVehiclesManager", downgradeComponent({ component: CameraVehiclesManagerComponent }))
    .directive("autoDownloadConfiguration", downgradeComponent({component: AutoDownloadConfigurationComponent }))
    .directive("autoDownloadConfigurationEditor", downgradeComponent({component: AutoDownloadConfigurationEditorComponent }))
    .directive("cameraThumbnail", downgradeComponent({ component: ChannelThumbnailComponent }))

    .service("deviceProfileService", downgradeInjectable(DeviceProfileService))

    ;
